import React from "react";

import Link from "shared/components/Link";
import Str from "shared/components/Str";

import "./SignupLink.scss";

if (process.env.PLATFORM === "mobile") {
	require("./SignupLink.mobile.scss");
} else {
	require("./SignupLink.desktop.scss");
}

const SignupLink = () => {
	return (
		<Link
			className="footer-signup"
			to="/signup"
		>
			<Str>Join OkCupid</Str>
		</Link>
	);
};

export default SignupLink;



// WEBPACK FOOTER //
// ./src/shared/components/Footer/SignupLink.jsx